import { Link } from "react-router-dom";
import { EmptyState } from "@/components/v2/EmptyState";

export function NotFoundPage() {
  return (
    <div className="space-y-4">
      <EmptyState title="Page not found" description="The route you opened does not exist." />
      <div className="text-center text-sm">
        <Link to="/" className="text-primary hover:underline">
          Return to overview
        </Link>
      </div>
    </div>
  );
}
